import { createInitialAsyncDownloadState } from 'partner360/components/asyncContentWrapper/model'

import { IReportsState } from '../model'

export const initialState: IReportsState = {
  download: createInitialAsyncDownloadState(),
  exportPptx: {
    isLoading: false,
  },
  multiExport: {
    isGenerating: false,
    generatedReportsIds: [],
  },
  products: [],
}
